import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function useAuthUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 NEW: Start as loading

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      setLoading(false); // 👈 Stop loading once Firebase responds
    });

    return () => unsubscribe();
  }, []);

  return { user, loading }; // 👈 Return both values
}